import { Link } from "react-router-dom";
import type { EventItem } from "@/types/content";
import { formatDateShort, formatHeat } from "@/utils/format";

interface EventCardProps {
  event: EventItem;
  index?: number;
}

export default function EventCard({ event, index = 0 }: EventCardProps) {
  return (
    <article
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
      style={{ animation: "fade-up 0.6s ease-out both", animationDelay: `${index * 60}ms` }}
    >
      <Link to={`/archive/${event.slug}`} className="block">
        <div className="relative h-44 w-full overflow-hidden bg-background-200 md:h-48">
          <img
            src={event.image}
            alt={`${event.title} — 独家吃瓜事件复盘配图`}
            title={`${event.title} 独家吃瓜事件复盘`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-md bg-foreground-950/75 px-2.5 py-1 text-xs font-medium text-background-50">
            {event.category}
          </span>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span>{formatDateShort(event.date)}</span>
          <span className="h-3 w-px bg-background-300"></span>
          <span>{event.readTime}</span>
          <span className="ml-auto flex items-center gap-1 text-primary-600">
            <i className="ri-fire-line"></i>
            {formatHeat(event.heat)}
          </span>
        </div>

        <h3 className="mt-3 font-heading text-base font-bold leading-7 text-foreground-950">
          <Link to={`/archive/${event.slug}`} className="transition-colors hover:text-primary-600">
            {event.title}
          </Link>
        </h3>

        <p className="mt-2 line-clamp-3 text-sm leading-6 text-foreground-600">{event.excerpt}</p>

        <div className="mt-4 flex flex-wrap gap-2">
          {event.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-50 px-2.5 py-1 text-xs text-secondary-800"
            >
              #{tag}
            </span>
          ))}
        </div>

        <Link
          to={`/archive/${event.slug}`}
          className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          阅读完整复盘
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </article>
  );
}